import {JetView} from "webix-jet"; // Importing JetView from webix-jet for creating views
import {getColor} from "helpers/chartcolors"; // Importing getColor function for color management
import {devConfig} from "../../../config/config"; // Importing development configuration

/**
 * MarketingView class extends JetView to create a marketing statistics view.
 */
export default class MarketingView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service for translations
        var multiple_dataset = [ // Sample dataset for chart
            {"date": "2018-08-14", "clicks": 2}, 
            {"date": "2018-08-16", "clicks": 1}, 
            {"date": "2018-08-17", "clicks": 2}, 
            {"date": "2018-08-18", "clicks": 3}
        ];
        return {
            type: "clean", // Clean layout type
            rows: [
                {template: _("Estadisticas Marketing"), type: "header", css: "webix_header chart_header"}, // Header template
                {
                    view: "chart", // Chart component
                    height: 250, // Height of the chart
                    type: "line", // Line chart type
                    localId: "chart", // Local ID for referencing the chart
                    xAxis: {
                        template: "'#date#", // X-axis template for date
                        title: _("Fecha"), // X-axis title
                    },
                    yAxis: {
                        start: 0, // Starting point of Y-axis
                        step: 10, // Step size for Y-axis
                        title: _("Valor") // Y-axis title
                    },
                    legend: {
                        values: [ // Legend values for the chart
                            {text: "Clicks", color: "#1293f8"},
                            {text: _("Visitas Links"), color: "#66cc00"},
                            {text: _("Registros"), color: "#ff572d"}
                        ],
                        align: "right", // Legend alignment
                        valign: "middle", // Legend vertical alignment
                        layout: "y", // Legend layout direction
                        width: 100, // Legend width
                        margin: 8 // Margin around the legend
                    },
                    series: [ // Data series for the chart
                        {
                            value: "#clicks#", // Data field for clicks
                            item: {
                                borderColor: "#1293f8", // Border color for item
                                color: "#ffffff" // Item color
                            },
                            line: {
                                color: "#1293f8", // Line color
                                width: 3 // Line width
                            },
                            tooltip: {
                                template: "#clicks#" // Tooltip template for clicks
                            }
                        },
                        {
                            value: "#visits#", // Data field for visits
                            item: {
                                borderColor: "#66cc00", // Border color for item
                                color: "#ffffff" // Item color
                            },
                            line: {
                                color: "#66cc00", // Line color
                                width: 3 // Line width
                            },
                            tooltip: {
                                template: "#visits#" // Tooltip template for visits
                            }
                        },
                        {
                            value: "#register#", // Data field for registrations
                            item: {
                                borderColor: "#ff572d", // Border color for item
                                color: "#ffffff" // Item color
                            },
                            line: {
                                color: "#ff572d", // Line color
                                width: 3 // Line width
                            },
                            tooltip: {
                                template: "#register#" // Tooltip template for registrations
                            }
                        }
                    ]
                }
            ]
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const _ = this.app.getService("locale")._; // Localization service for translations
        const cur_user = this.getParam("user", true); // Get current user parameter
        var vthis = this; // Preserve context for event handlers

        // Event listener for marketing statistics updates
        this.on(this.app, "statisticsAgent:marketing", data => {
            vthis.$$("chart").clearAll(); // Clear existing chart data
            vthis.$$("chart").parse(data); // Parse new data into the chart
        });

        // Event listener for date range updates
        this.on(this.app, "statisticsAgent:date2", date => {
            var dateRange = date; // Store the date range
            webix.ajax().headers({ // AJAX request to fetch marketing statistics
                "Content-type": "application/json"
            }).post(devConfig.geturlApi() + "Agent/GetMarketingStats", 
                '{ "AgentId":' + cur_user + ', "FromDateLocal":"' + dateRange.FromDateLocal + '", "ToDateLocal":"' + dateRange.ToDateLocal + '"}', 
                {
                    error: function (text, data, XmlHttpRequest) { // Error handling
                        webix.message(_("Error! ")); // Display error message
                    },
                    success: function (text, data, XmlHttpRequest) { // Success handling
                        var data = JSON.parse(text); // Parse response data
                        vthis.$$("chart").clearAll(); // Clear existing chart data
                        vthis.$$("chart").parse(data.result.charts.MediaStat.records); // Parse new data into the chart
                    }
                }
            );
        });
    }
}

// FILE DOCUMENTED
